import { Controller } from "@hotwired/stimulus"

// Controller for expanding/collapsing project detail sections
// Accordion behavior: only one project expanded at a time
export default class extends Controller {
  static values = { projectId: Number }

  expand(event) {
    const summary = this.element.closest(".project-summary")

    // If already expanded, collapse it (toggle behavior)
    if (summary && summary.classList.contains("expanded")) {
      event.preventDefault()
      this.collapse(event)
      return
    }

    // Collapse any other expanded projects first (accordion)
    this.collapseAllOthers()

    // Add expanded class to this summary row
    if (summary) {
      summary.classList.add("expanded")
    }
  }

  collapse(event) {
    if (event) event.preventDefault()

    const projectId = this.projectIdValue
    const detailFrame = document.getElementById(`detail_project_${projectId}`)

    if (detailFrame) {
      // Clear the frame content
      detailFrame.innerHTML = ""
    }

    // Remove expanded class from summary
    const summaryFrame = document.getElementById(`summary_project_${projectId}`)
    if (summaryFrame) {
      const summary = summaryFrame.querySelector(".project-summary")
      if (summary) {
        summary.classList.remove("expanded")
      }
    }
  }

  collapseAllOthers() {
    // Find all expanded project summaries and collapse them
    document.querySelectorAll(".project-summary.expanded").forEach(summary => {
      const controller = this.application.getControllerForElementAndIdentifier(
        summary,
        "project-expand"
      )
      if (controller && controller !== this) {
        controller.collapse()
      }
    })
  }
}
